import { render, staticRenderFns } from "./UserSettingTransportation.vue?vue&type=template&id=37c5dfea&scoped=true&"
import script from "./UserSettingTransportation.vue?vue&type=script&lang=js&"
export * from "./UserSettingTransportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5dfea",
  null
  
)

export default component.exports